module.exports = __webpack_public_path__ + "img/microplastics-process-5-mobile.4e1fbed5.png";